import { DefaultAttributeId, getDefaultObjectId, ObjectType, syncIdAttributeByUuid } from '../../utils/attributes/defaultObjectsAndAttributes';
import Entity, { IEntity } from '../abstract/Entity';
import { IAttribute } from './AttributeModel';
import { ISpace } from './SpaceModel';

export interface IRoom extends IEntity {
  title: string;
  spaces: Array<ISpace>;
}

class RoomModel extends Entity implements IRoom {
  title: string;

  spaces: Array<ISpace>;

  readonly filesApiId: number = getDefaultObjectId(ObjectType.Room);

  constructor(title: string = '', spaces: Array<ISpace> = [], attributes: Array<IAttribute> = [], uuid: string | undefined = undefined) {
    super(attributes);
    if (uuid) {
      this.uuid = uuid;
    }
    this.title = title;
    this.spaces = spaces;
    const synced = syncIdAttributeByUuid(this.attributes, DefaultAttributeId.ROOM_ID, this.uuid);
    if (synced) this.attributes = synced;
  }
  
  override setUUID(uuid: string) {
    super.setUUID(uuid);
    const synced = syncIdAttributeByUuid(this.attributes, DefaultAttributeId.ROOM_ID, this.uuid);
    if (synced) this.attributes = synced;
  }

  getTitle(): string {
    return this.title;
  }

  setTitle(value: string): void {
    this.title = value;
  }

  getSpaces(): Array<ISpace> {
    return this.spaces;
  }

  getSpacesById(uuid: string) {
    return this.spaces.find((space) => space.uuid === uuid);
  }

  setSpaces(value: Array<ISpace>): void {
    this.spaces = value;
  }

  addSpace(value: ISpace): void {
    this.spaces.push(value);
  }

  toJSON() {
    return {
      ...super.toJSON(),
      title: this.title,
      spaces: this.spaces.map((s) => s.toJSON()),
    };
  }
}
export default RoomModel;
